import React from 'react';
import { Collapse } from 'components/Transition';
import './style.scss';

interface LangSwitchProps {
    language: string;
    onClick: React.MouseEventHandler;
    showLanguageMenu: boolean;
}

const LangSwitch: React.FC<LangSwitchProps> = props => {
    const { language, onClick, showLanguageMenu } = props;

    return (
        <div className="dropdown lang-switch-root">
            <a href="#0" className="dropdown-toggle nav-link" onClick={onClick}>
                {language === 'zh_CN' ? '简' : 'EN'}
            </a>
            <Collapse in={showLanguageMenu}>
                <div className="dropdown-menu show">
                    <a className="dropdown-item btn" href="?lang=zh_CN">
                        简
                    </a>
                    <div className="dropdown-divider"></div>
                    <a className="dropdown-item btn" href="?lang=en_US">
                        EN
                    </a>
                </div>
            </Collapse>
        </div>
    );
};

export default LangSwitch;
